import { RouteNode, IAction } from '@wildberries/service-router';
import { ReduxStoreLoader } from '@mihanizm56/redux-core-modules';
import i18next from 'i18next';
import { MAIN_PAGE_TRANSLATIONS } from '@/pages/supplies-management/_constants/translations';
import { MainLayout } from '@/pages/supplies-management/_layout/main-layout';
import { WAREHOUSES_LIMITS_PAGE_NODE } from '@/_constants/page-node';
import { Page } from './page';
import { storeInjectConfig } from './store-inject-config';

const action: IAction = async ({ toState }) => {
  return {
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.warehousesCoefficientsTitle),
    content: (
      <ReduxStoreLoader
        storeInjectConfig={storeInjectConfig()}
        toState={toState}
      >
        <MainLayout createSupply="warehousesLimits">
          <RouteNode nodeName={WAREHOUSES_LIMITS_PAGE_NODE}>
            {({ route, content }) => {
              return route.name === WAREHOUSES_LIMITS_PAGE_NODE ? (
                <Page />
              ) : (
                content
              );
            }}
          </RouteNode>
        </MainLayout>
      </ReduxStoreLoader>
    ),
  };
};

export default action;
